import { Helmet } from 'react-helmet-async';

// Actually, the rule says "Prohibited to use react-helmet-async; Reference use React 19 features instead."
// Let me use a simpler approach - injecting JSON-LD via script tag in the component

import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotSearchBar from './components/HotSearchBar';
import FeaturedGrid from './components/FeaturedGrid';
import CategoryCards from './components/CategoryCards';
import HotArticleList from './components/HotArticleList';
import Testimonials from './components/Testimonials';
import CTASection from './components/CTASection';
import FAQSection from './components/FAQSection';
import BrandIntro from './components/BrandIntro';
import { useEffect } from 'react';

const schemaData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": "https://www.chiguawang.com/#organization",
      "name": "吃瓜网",
      "url": "https://www.chiguawang.com",
      "description": "吃瓜网官网 — 明星八卦黑料大全、网红翻车实锤证据、擦边内容聚合平台。八卦有理，吃瓜无罪。",
      "sameAs": [
        "https://weibo.com/chiguawang",
        "https://www.douyin.com/user/chiguawang"
      ]
    },
    {
      "@type": "WebSite",
      "@id": "https://www.chiguawang.com/#website",
      "url": "https://www.chiguawang.com",
      "name": "吃瓜网官网",
      "description": "🔥吃瓜网官网收录明星八卦黑料大全与网红翻车实锤证据，整合擦边内容聚合与历年经典大瓜事件，🏆八卦有理吃瓜无罪。",
      "publisher": {
        "@id": "https://www.chiguawang.com/#organization"
      },
      "inLanguage": "zh-CN"
    },
    {
      "@type": "WebPage",
      "@id": "https://www.chiguawang.com/#webpage",
      "url": "https://www.chiguawang.com",
      "name": "吃瓜网官网首页 - 明星八卦黑料大全 | 网红翻车实锤 | 擦边内容聚合",
      "description": "🔥吃瓜网官网收录明星八卦黑料大全与网红翻车实锤证据，整合擦边内容聚合与历年经典大瓜事件，🏆八卦有理吃瓜无罪。免费秒开无卡顿，🍑全民参与爆料大赛，立即访问吃瓜官网抢占第一排！",
      "isPartOf": {
        "@id": "https://www.chiguawang.com/#website"
      },
      "about": {
        "@id": "https://www.chiguawang.com/#organization"
      },
      "primaryImageOfPage": {
        "@type": "ImageObject",
        "url": "https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20night%20scene%20of%20a%20crowd%20of%20people%20holding%20smartphones%20up%20toward%20a%20glowing%20stage&width=1920&height=900&seq=gossip-hero-bg&orientation=landscape"
      },
      "inLanguage": "zh-CN"
    }
  ]
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "吃瓜网的内容都是真实的吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "吃瓜网致力于提供真实、可靠的爆料内容。我们的内容来源包括用户投稿、专业狗仔爆料、以及多方交叉验证的信息。每篇爆料文章都会标注信息来源和可信度评级，让用户自行判断。"
      }
    },
    {
      "@type": "Question",
      "name": "如何参与爆料大赛？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "点击页面上的立即爆料按钮，填写你的爆料内容和相关证据，提交后审核团队会在24小时内进行审核。通过审核的爆料将自动参与当月爆料大赛。"
      }
    },
    {
      "@type": "Question",
      "name": "吃瓜网收费吗？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "完全不收费！吃瓜网是一个免费的娱乐资讯聚合平台，所有内容均可免费浏览。我们承诺永久免费，不会设置付费墙或会员专属内容。"
      }
    },
    {
      "@type": "Question",
      "name": "为什么有些内容被删除了？",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "内容删除通常出于被证实为不实信息、涉及当事人隐私权投诉、或违反相关法律法规要求。我们重视内容合规性，也尊重当事人的合法权益。"
      }
    }
  ]
};

const breadcrumbSchema = {
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  "itemListElement": [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "首页",
      "item": "https://www.chiguawang.com"
    }
  ]
};

export default function Home() {
  useEffect(() => {
    // Inject JSON-LD schemas
    const schemas = [schemaData, faqSchema, breadcrumbSchema];

    const scriptIds: string[] = [];
    schemas.forEach((schema, index) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.id = `schema-jsonld-${index}`;
      script.textContent = JSON.stringify(schema);
      document.head.appendChild(script);
      scriptIds.push(script.id);
    });

    return () => {
      scriptIds.forEach(id => {
        const el = document.getElementById(id);
        if (el) el.remove();
      });
    };
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <HotSearchBar />
        <FeaturedGrid />
        <CategoryCards />
        <HotArticleList />
        <Testimonials />
        <CTASection />
        <FAQSection />
        <BrandIntro />
      </main>
      <Footer />
    </>
  );
}